/**
 * Created by sunshine on 2016/12/15.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import cashome from './cashome'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<cashome/>',
  components: {cashome}
})



// WEBPACK FOOTER //
// ./src/pages/cashome/index.js